import React from 'react';

import { StyleProp, View, ViewStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

import { getParentalRatingIcon } from 'assets/images';

import { EventParentalControlRating } from 'services/data-manager/types';

import { isWeb } from 'utils/responsiveness';

import styles from 'components/ContentMarkerIcons/ParentalRatingMarker/styles';
import { getParentalRatingAccessibilityText } from 'components/ContentMarkerIcons/ParentalRatingMarker/utils';

type Props = {
    parentalRating?: EventParentalControlRating | undefined;
    style?: StyleProp<ViewStyle>;
    parentalRatingTestID?: string;
    size?: number;
    tabIndex?: 0 | -1;
};

const ParentalRatingMarker = ({
    parentalRating,
    style,
    parentalRatingTestID,
    size = 24,
    tabIndex,
}: Props) => {
    const { t } = useTranslation();

    const accessibilityLabel = t(
        getParentalRatingAccessibilityText(parentalRating),
    );
    const ParentalRatingIcon = getParentalRatingIcon(parentalRating);

    return (
        <View
            style={[styles.marker, style]}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole="image"
            accessible
            {...(isWeb && { tabIndex })}
        >
            <ParentalRatingIcon
                testID={parentalRatingTestID}
                width={size}
                height={size}
            />
        </View>
    );
};

export default ParentalRatingMarker;
